export const LOGOUT = "auth/LOGOUT";

export interface ILogout {
  type: typeof LOGOUT;
}

export type AuthActionTypes = ILogout;
